/*eslint-disable import/default */
// per la traduzione di funzione ES6 in ES5
// utilizzato anche per funzioni di Redux

import 'babel-polyfill';
import React from 'react';
import {render} from 'react-dom';
import configureStore from './store/configureStore';
import { Router } from 'react-router';
// libreria che esegue l'attach dello state di redux al container di react
import {Provider} from 'react-redux';
import routes from './routes';
import 'Content/Assets/css/animate.css';
import 'Content/Assets/fonts/Neo_Sans.ttf';
import 'toastr/build/toastr.min.css';
import 'font-awesome/css/font-awesome.css'
import 'layouts/material-admin/material-admin.css';
import "video-react/dist/video-react.css"; // import css

import * as localizationServices from 'services/localization/localizationServices';
import { useBasename } from 'history';
import { initIsAuthenticated }  from 'actions/userActions';
import { loadAppData } from 'actions/appDataActions';
import injectTapEventPlugin from 'react-tap-event-plugin';
import * as settings from 'settings/settings';
import ReactGA from 'react-ga';

console.log("using google analytics key " + settings.googleAnalyticsKey);
ReactGA.initialize(settings.googleAnalyticsKey); //Unique Google Analytics tracking number
// This just needs to be called once since we have no routes in this case.
ReactGA.pageview(window.location.pathname);

console.log("starting React App");

const {store, history} = configureStore();

/*
    verifico se l'utente è già loggato.
    quando ci clicca su Login l'applicativo crea un cookie con dentro il baseUri e apikey.
    In linea del tutto toerica: se ti loggi su CalAmp ottieni un cookie con un authToken, se l'applicativo viene ri-eseguito allora
    dovresti avere ancora lo stesso cookie di CalAmp
*/
console.log("initIsAuthenticated dispatched");
store.dispatch(initIsAuthenticated());

/*
    carico in memoria liste utili un pò tutte le pagine
*/
store.dispatch(loadAppData());
/*
    init della localizzazione
*/
localizationServices.init(store);
/*
    leggo dal client la lingua corrente
*/
var language = (navigator.languages && navigator.languages[0]) ||
               navigator.language ||
               navigator.userLanguage;

localizationServices.setLanguage(language, store);
//localizationServices.setLanguage("es-ES", store);

/*
    baseaddress
*/
let baseName = settings.baseName;

injectTapEventPlugin();

render(
    <Provider store={store}>
        <div>
            <Router history={ useBasename(() => history)({ basename: baseName })} routes={routes} />
        </div>
    </Provider>
    ,document.getElementById("root"));


// WEBPACK FOOTER //
// ./src/index.js